export default __webpack_public_path__ + "static/media/3-sgi-home-v2.png:Zone.0543b9e3.Identifier";